<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      title="班组"
      id-key="UserId"
      :data="data"
      @edit-opened="opened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row class="border">
          <el-row :gutter="15">
            <el-col :span="20">
              <el-form-item label="选择班组">
                <el-select v-model="data.TeamId" @change="changeTeam">
                  <el-option v-for="(item) in teamList" :key="item.TeamId" :value="item.TeamId" :label="item.Team"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="20">
              <el-form-item label="班次">
                <el-select v-model="data.ScheduleId" >
                  <el-option v-for="(item) in scheduleList" :key="item.ScheduleId" :value="item.ScheduleId" :label="item.Schedule"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </template>

      <template slot="footer">
        <el-button type="primary" @click="save" >保存</el-button>
          <el-button @click="closeDialog">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>

<script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";

  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
    },
    props: {
      wid: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        api: require("@/api/ba/team").default,
        planApi: require("@/api/pu/plan").default,
        data: {
          WorkDocIds: [],
          TeamId: null,
          Team: "",
          ScheduleId: null,
          Schedule: ""
        },
        teamList: [],
        copyTeamList: [],
        scheduleList: [],

      };
    },
    created(){
      
      this.api.list({}).then(res => {
        if(res.Code === 0){

          this.copyTeamList = JSON.parse(JSON.stringify(res.Data));
          
          let teamIds = [];
          let arr = [];
          res.Data.forEach(item => {
            let index = teamIds.indexOf(item.Team);
            if(index === -1){
              arr.push({
                Team: item.Team,
                TeamId: item.TeamId,
              })
            }
            teamIds.push(item.Team)
          })
          this.teamList = arr;


        }
      })

      
    },
    methods: {
      save(){

        if(this.data.ScheduleId == null || this.data.TeamId == null){

          this.$message({type: 'warning', message: '请选择班组和班次'})

          return

        };
        var loading = this.$loading({
            lock: true,
            text: "正在保存...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });

        this.planApi.changeTeam(this.data).then(res => {
          if(res.Code === 0){
            this.$message({type: 'success', message: res.Msg})
            this.$emit('change', this.data)
            loading.close();
            this.close();
          }else{
            this.$message({type: 'warning', message: res.Msg})
            loading.close();
          }
        }).catch(err => {
          console.error(err);
          loading.close();
        })
      }, 
      closeDialog(){
        this.close()
      },
      opened(row){
        console.log('row', row)
        this.data.WorkDocIds = row.WorkDocIds;
        this.data.TeamId = row.TeamId;
        this.data.Team = row.Team;
        this.data.ScheduleId = row.ScheduleId;
        this.data.Schedule = row.Schedule;

        let scheduleList = this.copyTeamList.filter(item => {
          return this.data.Team === item.Team;
        })

        this.scheduleList = scheduleList
      },
      changeTeam(val){

        this.data.ScheduleId = null;
        this.data.Schedule = "";


        let item = this.copyTeamList.filter(item => {
          return item.TeamId === val;
        })[0]
        this.data.TeamId = item.TeamId;
        this.data.Team = item.Team;
        
        let scheduleList = this.copyTeamList.filter(item => {
          return this.data.Team === item.Team;
        })

        this.scheduleList = scheduleList

       

      }
    },
  };
</script>
